const hasWhiteSpaces = value => /\s/.test(value);

const isValidLoyaltyId = value => /^\d{9}$/.test(value);

const isValidEmail = value =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);

export const validateFormatLoyaltyIdEmail = (loyaltyID, email) => {
  return {
    loyaltyID:
      !!loyaltyID && !hasWhiteSpaces(loyaltyID) && isValidLoyaltyId(loyaltyID),
    email: !!email && !hasWhiteSpaces(email) && isValidEmail(email),
  };
};
